export default __webpack_public_path__ + "static/media/Revealr_Yellow.b93cb1cd.png";